import { AuthSuccessGrant } from '@chegg/wtf-components'
import { NextJsRoute } from '@chegg-wt/core/types/core'
import { FetchUserResponse } from '@chegg-wt/core/types/auth'
import {
  MemberRole,
  SchoolType,
} from '@chegg/wtf-components/dist/types/opencomponents/cheggAuth'
import { SADefaultFlow } from '@chegg-wt/core/constants/site'

export interface LoadAuthPayload {
  defaultflow: SADefaultFlow.LOGIN | SADefaultFlow.SIGN_UP
  client: string
  redirectTo: NextJsRoute
  authDataOptions?: AuthDataOptions
}

export interface LoginPayload {
  saOptions: AuthSuccessGrant
  redirectTo: NextJsRoute
}

export interface FetchUserPayload {
  redirectTo?: NextJsRoute
}

export interface FetchUserMeta {
  authType?: AuthSuccessGrant['auth_type']
  authMethod?: AuthSuccessGrant['auth_method']
}

export interface UserState extends FetchUserResponse {
  dataMigrationInProgress?: boolean
  isLoading: boolean
  readonly selectedUserType?: MemberRole
  readonly selectedSchoolType?: SchoolType
  hasPaper?: boolean
}

export interface ErrorMeta {
  error: string
}

export interface AuthDataOptions {
  valueprop?: ValueProps
}

export interface ValueProps {
  header: string
  subheader?: string
  bullet1: string
  bullet2?: string
  bullet3?: string
  bullet4?: string
  footer?: string
  bulletHexColor: string
  colorTheme: ValuePropColorTheme
}

export type ValuePropColorTheme = 'light' | 'dark'

export enum AuthRedirectActions {
  CREATE_CITATION = 'create-citation',
}
